import { GRAPHQL } from './http.client'
import userMonitoring from '@/mixins/userMonitoring'
import CarMakesQuery from '@/api/queries/CarMakes.graphql'
import { ApolloError } from '@apollo/client'
import { CarMake } from '@/types/generated-types'

export const getCarMakesRequest = (): Promise<CarMake[]> => {
  return GRAPHQL.query<any>({
    query: CarMakesQuery,
    variables: {
      siteId: import.meta.env.VITE_SiteId,
    },
    errorPolicy: 'all',
  })
    .then((response) => {
      if (response.errors) {
        userMonitoring().trackErrorGraphql('CarMakesQuery', JSON.stringify(response.errors))
      }
      return response.data.carMakes as CarMake[]
    })
    .catch((error: ApolloError) => {
      userMonitoring().trackErrorGraphql('CarMakesQuery', error)
      return [] as CarMake[]
    })
}
